import { createSlice } from '@reduxjs/toolkit';

import { InquiryDetails } from '../../../../models/inquiries';

import { handleGetInquiryDetails } from './actions';
import { IInquiryDetailsState } from './slice.interface';

const initialState: IInquiryDetailsState = {
  data: null,
  isLoading: false,
  error: false,
};

export const inquiryDetailsSlice = createSlice({
  name: 'inquiry-details',
  initialState,
  reducers: {
    removeInquiryDetails: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetInquiryDetails.pending, (state: IInquiryDetailsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetInquiryDetails.rejected, (state: IInquiryDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetInquiryDetails.fulfilled, (state: IInquiryDetailsState, action) => {
        state.data = new InquiryDetails(action?.payload?.data);
        state.isLoading = false;
      });
  },
});

export const { removeInquiryDetails } = inquiryDetailsSlice.actions;

export default inquiryDetailsSlice.reducer;
